// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"e7f72c1e","86":"1758af75","129":"b9c20cb6","131":"52b724fa","134":"523bb13c","248":"184a7cf9","362":"83e7d555","386":"114f4be0","773":"a989e909","801":"4096461f","806":"c2e72091","906":"385b64d9"}[chunkId] + ".chunk.js";
};